/** 权益类型枚举 */
export enum PermissionType {
  /** 无限积分 */
  UNLIMITED_CREDIT = 'UNLIMITED_CREDIT',
  /** 发布网站数量 */
  PUBLISH_WEBSITE_NUM = 'PUBLISH_WEBSITE_NUM',
  /** 每个网站的页面数量限制 */
  PAGE_COUNT_LIMIT = 'PAGE_COUNT_LIMIT',
  /** 自定义代码 */
  CUSTOM_CODE = 'CUSTOM_CODE',
  /** 自定义域名 */
  CUSTOM_HOST = 'CUSTOM_HOST',
  /** 移除品牌标识 */
  REMOVE_BADGE = 'REMOVE_BADGE',
  /** 免费自定义域名 */
  FREE_CUSTOM_DOMAIN = 'FREE_CUSTOM_DOMAIN',
  /** Google Analytics */
  GA = 'GA',
  /** 积分 */
  POINTS = 'POINTS',
}

/** 后端权益检查类型 */
export enum PermissionCheckType {
  UNLIMITED_CREDIT = 'UNLIMITED_CREDIT',
  PUBLISH_WEBSITE_NUM = 'PUBLISH_WEBSITE_NUM',
  PAGE_NUM_PER_WEBSITE = 'PAGE_NUM_PER_WEBSITE',
  CUSTOM_CODE = 'CUSTOM_CODE',
  CUSTOM_DOMAIN = 'CUSTOM_DOMAIN',
  REMOVE_BRAND = 'REMOVE_BRAND',
  FREE_CUSTOM_DOMAIN = 'FREE_CUSTOM_DOMAIN',
  GOOGLE_ANALYZE = 'GOOGLE_ANALYZE',
  PUBLISH_REMAIN_TIME = 'PUBLISH_REMAIN_TIME',
}

/** 无限制标识 */
export const Unlimited = -1;

/** 后端返回的无限制标识 */
export const UNLIMITED = -1;

/** 免费计划页面限制 */
export const FREE_PAGE_LIMIT = 5;

/** 基础计划页面限制 */
export const BASIC_PAGE_LIMIT = 10;

/** Pro 计划页面限制 */
export const PRO_PAGE_LIMIT = 50;
